import * as types from '../types.js';

export default {
	html: `
		<form id="inputs-print-documents-list" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<p class="fss">Controle documental por empenho e NF. Exporte em <strong>Excel</strong>, <strong>CSV</strong> ou <strong>PDF</strong> (campo Formato abaixo).</p>
			<div class="fsb">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label>Data inicial<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Data final<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="fsb">
				<label>Base do período
					<select id="date_basis">
						<option value="created">Data de criação da entrada</option>
						<option value="received">Data de recebimento</option>
						<option value="completed">Data de conclusão (endereçamento)</option>
					</select>
				</label>
				<label>Armazém (opcional)
					<select id="warehouse_id"><option value="">Todos</option></select>
				</label>
				<label>Status (opcional)
					<select id="status">
						<option value="">Todos</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label>
					<input id="empenho_only" type="checkbox" value="1">
					Somente com empenho informado
				</label>
				<label>Exportar como<sup>*</sup>
					<select id="format" name="format">
						<option value="xlsx">Excel (.xlsx)</option>
						<option value="csv">CSV (texto separado por ;)</option>
						<option value="pdf">PDF</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span id="idl-count-msg" class="fss" style="color:#666;"></span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#inputs-print-documents-list',
		init(formset) {
			const root = formset.form?.selector || '#inputs-print-documents-list';
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const stSel = document.querySelector(`${root} #status`);
			const st = types.opt_input_status();
			if (stSel && st?.options) {
				for (const o of st.options) {
					const opt = document.createElement('option');
					opt.value = o.value;
					opt.textContent = o.label;
					stSel.appendChild(opt);
				}
			}
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#date_from' }, types: [] },
		{ properties: { selector: '#date_to' }, types: [] },
		{ properties: { selector: '#date_basis' }, types: [] },
		{ properties: { selector: '#warehouse_id' }, types: [] },
		{ properties: { selector: '#status' }, types: [] },
		{ properties: { selector: '#empenho_only' }, types: [] },
		{ properties: { selector: '#format' }, types: [] },
		{ properties: { selector: '#idl-count-msg' }, types: [] },
	],
};
